import React from 'react';
import Typography from '@material-ui/core/Typography';
import { areTimeSlotsEnabled } from '../helper';

const RecurringPlanString = ({
  rruleCombined,
  variant = 'h6',
  selectedTimeSlot = null,
}) => {
  const isUsingTimeSlots = areTimeSlotsEnabled();

  return (
    <Typography variant={variant}>
      {rruleCombined
        .toText()
        .charAt(0)
        .toUpperCase() + rruleCombined.toText().slice(1)}
      {selectedTimeSlot && isUsingTimeSlots && <> at {selectedTimeSlot}</>}
    </Typography>
  );
};

export default RecurringPlanString;
